module.exports = __webpack_public_path__ + "static/media/display02.a5bf8ff4.jpg";